const queries = {
  subscription: (id: number) => ['subscriptions', id],
  subscriptionList: () => ['subscriptions'],
}

export default queries
